import { AlertCircle } from 'lucide-react';

interface ErrorMessageProps {
    message?: string;
    className?: string;
}

export function ErrorMessage({ message, className = '' }: ErrorMessageProps) {
    if (!message) return null;

    return (
        <p className={`text-red-500 text-sm mt-1 flex items-center gap-1 ${className}`}>
            <AlertCircle className="w-3 h-3 flex-shrink-0" />
            {message}
        </p>
    );
}
